/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/naming-convention */
import Service, { DomainMetadata } from '../lib/App';
import { isProduction } from './environment';

export enum DomainFamily {
  TRANSPORT = 't',
  CHAOS = 'c',
}

interface DomainFamilyConfig {
  name: string;
}

export const DOMAIN_FAMILY_CONFIG: {
  [key: string]: DomainFamilyConfig;
} = {
  [DomainFamily.TRANSPORT]: {
    name: 'transport',
  },
  [DomainFamily.CHAOS]: {
    name: 'chaos',
  },
};

const domainFamilyKeys: string[] = Object.keys(DomainFamily).map(
  (key: string): string => DomainFamily[key],
);

// In production, only transport domain is valid yet
export const isValidDomainFamily = (df: string): boolean =>
  isProduction ? df === DomainFamily.TRANSPORT : domainFamilyKeys.includes(df);

// Eg:- capture 'c' in  https://experiments.stg-myteksi.com/c/experiments/scheduled
const extractDomainFamilyKeyRegx = new RegExp(
  `^\/(${domainFamilyKeys.join('|')})\/.+$`,
);

export function getDomainFamily(): DomainFamily | undefined {
  const execArray = extractDomainFamilyKeyRegx.exec(window.location.pathname);
  if (execArray && execArray.length > 1) {
    const key = execArray[1];
    if (domainFamilyKeys.includes(key)) {
      return key as DomainFamily;
    }
  }
  return undefined;
}

// Returns current and active list of domain
export function getCurrentDomains(): DomainMetadata[] {
  const domains: DomainMetadata[] = [];
  const family = getDomainFamily();
  if (family !== undefined) {
    const familyName = DOMAIN_FAMILY_CONFIG[family].name;
    const domainMetadata = Service.cache.getAllDomainMetadata();
    domainMetadata.forEach((domain) => {
      if (domain.family === familyName && domain.active) {
        domains.push(domain);
      }
    });
  }
  return domains;
}

// Returns current and active list of domain names
export const getCurrentDomainsNames = (): string[] =>
  getCurrentDomains().map((domain) => domain.name);

// Return all domains
export function getAllDomains(activeOnly?: boolean): DomainMetadata[] {
  const domainMetadata = Service.cache.getAllDomainMetadata();
  const domains = domainMetadata;
  if (activeOnly) {
    return domains.filter((domain) => domain.active);
  }
  return domains;
}

// Returns all domain names
export const getAllDomainsNames = (activeOnly?: boolean): string[] =>
  getAllDomains(activeOnly).map((domain) => domain.name);
